import React from 'react';
import './TechStack.css';

const technologies = [
  { name: 'React', icon: '⚛️', category: 'Frontend', color: '#61dafb' },
  { name: 'TypeScript', icon: '🔷', category: 'Language', color: '#3178c6' },
  { name: 'Node.js', icon: '🟢', category: 'Runtime', color: '#68a063' },
  { name: 'GPT-4', icon: '🧠', category: 'AI Engine', color: '#10a37f' },
  { name: 'Rust', icon: '🦀', category: 'Core Engine', color: '#dea584' },
  { name: 'WebAssembly', icon: '🔵', category: 'Performance', color: '#654ff0' },
  { name: 'Redis', icon: '🔴', category: 'Cache', color: '#dc382d' },
  { name: 'PostgreSQL', icon: '🐘', category: 'Database', color: '#336791' },
  { name: 'Docker', icon: '🐳', category: 'Container', color: '#2496ed' },
  { name: 'Kubernetes', icon: '☸️', category: 'Orchestration', color: '#326ce5' },
  { name: 'GraphQL', icon: '💜', category: 'API', color: '#e10098' },
  { name: 'WebSockets', icon: '🔌', category: 'Real-time', color: '#f59e0b' },
];

const TechStack = () => {
  return (
    <section className="tech" id="tech">
      <div className="tech__container">
        <div className="tech__header">
          <div className="tech__badge">🔧 Technology Stack</div>
          <h2 className="tech__title">
            Powered by <span className="tech__title-gradient">world-class technology</span>
          </h2>
          <p className="tech__subtitle">
            UltraCoder is built on a foundation of battle-tested, high-performance technologies
            chosen for reliability, speed, and developer experience.
          </p>
        </div>

        <div className="tech__grid">
          {technologies.map((tech, index) => (
            <div key={index} className="tech-card" style={{ '--tech-color': tech.color }}>
              <div className="tech-card__icon">{tech.icon}</div>
              <div className="tech-card__info">
                <h4 className="tech-card__name">{tech.name}</h4>
                <span className="tech-card__category">{tech.category}</span>
              </div>
              <div className="tech-card__bar">
                <div className="tech-card__bar-fill"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Performance Metrics */}
        <div className="tech__metrics">
          <h3 className="tech__metrics-title">Performance Benchmarks</h3>
          <div className="tech__metrics-grid">
            <div className="metric">
              <div className="metric__value">{'<'}50ms</div>
              <div className="metric__bar">
                <div className="metric__bar-fill" style={{ width: '95%', background: 'linear-gradient(90deg, #6366f1, #8b5cf6)' }}></div>
              </div>
              <div className="metric__label">Code Completion Latency</div>
            </div>
            <div className="metric">
              <div className="metric__value">2M+</div>
              <div className="metric__bar">
                <div className="metric__bar-fill" style={{ width: '85%', background: 'linear-gradient(90deg, #06b6d4, #6366f1)' }}></div>
              </div>
              <div className="metric__label">Lines of Code Analyzed/sec</div>
            </div>
            <div className="metric">
              <div className="metric__value">99.97%</div>
              <div className="metric__bar">
                <div className="metric__bar-fill" style={{ width: '99%', background: 'linear-gradient(90deg, #10b981, #06b6d4)' }}></div>
              </div>
              <div className="metric__label">AI Suggestion Accuracy</div>
            </div>
            <div className="metric">
              <div className="metric__value">{'<'}100MB</div>
              <div className="metric__bar">
                <div className="metric__bar-fill" style={{ width: '70%', background: 'linear-gradient(90deg, #f59e0b, #ef4444)' }}></div>
              </div>
              <div className="metric__label">Memory Footprint</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStack;